import { CSSProperties } from 'react';

import { Divider, FlexAligner, Typography } from '@scaleaq/scaleui';
import { useTranslation } from 'react-i18next';

import { HotKeyLineWithButtonAndDescription } from '@/components/HotKeyLineWithButtonAndDescription.tsx';
import {
  CameraControlHotKeyDefinitionsResult,
  useCameraControlHotKeyDefinitions,
} from '@/hooks/shortcutHooks/useHotkeyDefinitions/useCameraControlHotKeyDefinitions.tsx';
import {
  useWinchControlHotkeysDefinitions,
  WinchControlHotkeysDefinitionsResult,
} from '@/hooks/shortcutHooks/useHotkeyDefinitions/useWinchControlHotkeysDefinitions.tsx';
import { responsive } from '@/utils';

const DEFAULT_STYLE: CSSProperties = {
  width: '32rem',
  height: 'fit-content',
};

type CameraShortcutsProps = {
  style?: CSSProperties;
};

type CameraControlHotKeys = CameraControlHotKeyDefinitionsResult['cameraControlHotKeys'];
type CameraControlHoldRepeatHotkeys =
  CameraControlHotKeyDefinitionsResult['cameraControlHoldRepeatHotkeys'];

export const CameraShortcuts = ({ style = DEFAULT_STYLE }: CameraShortcutsProps) => {
  const { t } = useTranslation(['common']);
  const { cameraControlHotKeys, cameraControlHoldRepeatHotkeys } =
    useCameraControlHotKeyDefinitions();
  const winchControlHotkeys = useWinchControlHotkeysDefinitions();
  let iterationKey: number = 0;
  return (
    <FlexAligner
      direction='column'
      alignment={'center'}
      style={{ ...style }}
      gap={responsive.spacing['3xlarge']}
    >
      {(Object.keys(cameraControlHotKeys) as (keyof CameraControlHotKeys)[]).map(shortcut => {
        iterationKey = iterationKey + 1;
        const props = cameraControlHotKeys[shortcut];
        return (
          <HotKeyLineWithButtonAndDescription key={iterationKey + props.primary.code} {...props} />
        );
      })}
      {(
        Object.keys(cameraControlHoldRepeatHotkeys) as (keyof CameraControlHoldRepeatHotkeys)[]
      ).map(shortcut => {
        iterationKey = iterationKey + 1;
        const props = cameraControlHoldRepeatHotkeys[shortcut];
        return (
          <HotKeyLineWithButtonAndDescription key={iterationKey + props.primary.code} {...props} />
        );
      })}
      <Divider />
      {(Object.keys(winchControlHotkeys) as (keyof WinchControlHotkeysDefinitionsResult)[]).map(
        shortcut => {
          iterationKey = iterationKey + 1;
          const props = winchControlHotkeys[shortcut];
          return (
            <HotKeyLineWithButtonAndDescription
              key={iterationKey + props.primary.code}
              {...props}
            />
          );
        }
      )}
      <Divider />
      <FlexAligner direction={'column'} gap={responsive.spacing.xsmall}>
        <Typography type='heading_xsmall'>{`${t('common:remark')}:`}</Typography>
        <Typography style={{ paddingLeft: responsive.spacing.large }}>
          {t('common:messages.cameraControl.cOnlyAppliesINLayouts')}
        </Typography>
      </FlexAligner>
    </FlexAligner>
  );
};
